const API_BASE = process.env.REACT_APP_API_BASE_URL;
export async function fetchActivePromoImages({
  token,
  limit = 3,
  city = "",
} = {}) {
  const url = `${API_BASE}/api/promos/active-images?limit=${encodeURIComponent(limit)}${
    city ? `&city=${encodeURIComponent(city)}` : ""
  }`;
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error(`Promos fetch failed: ${res.status}`);
  return res.json(); // [{id, code, kind, value, image_url, starts_at, ends_at}]
}
